import React, { Component } from "react";
import PropTypes from "prop-types";
import OwInputWrapper from "../OwInputWrapper/OwInputWrapper";
import * as _ from "lodash-es";

type Props = {
    weight?: number;
    name: string;
    onChange: (e: React.ChangeEvent<any>) => void;
    disabled?: boolean;
};

type State = {
    pounds: number;
    ounces: number;
};

class OwWeightSelector extends Component<Props, State> {
    static defaultProps = {
        weight: 0,
    };

    readonly state: State = {
        pounds: 0,
        ounces: 0,
    };

    componentDidMount() {
        this.calculateValues();
    }

    calculateValues = () => {
        if (this.props.weight) {
            if (this.props.weight <= 0) {
                return;
            }

            const decimal = this.props.weight - Math.floor(this.props.weight);

            const ounces = decimal * 16;
            const pounds = this.props.weight - decimal;

            this.setState({
                pounds,
                ounces,
            });
        }
    };

    handleChange = (e: any) => {
        let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        value = parseInt(value);

        if (_.isNil(value) || _.isNaN(value)) {
            value = 0;
        }

        const state: any = {
            [name]: value,
        };

        this.setState(state, () => {
            let parsedPounds: number = this.state.pounds;

            if (!_.isNumber(this.state.pounds)) {
                parsedPounds = parseInt(this.state.pounds);
            }

            const parsedOunces = this.state.ounces / 16;

            const weight = parsedPounds + parsedOunces;

            const e: any = {
                target: {
                    type: "text",
                    name: this.props.name,
                    value: weight,
                },
            };

            this.props.onChange(e);
        });
    };

    render() {
        return (
            <div className="OwWeightSelector row">
                <div className={"col-4 d-inline-flex flex-column"}>
                    <div>Lbs.</div>
                    <div>
                        <OwInputWrapper
                            type={"number"}
                            min={0}
                            name={"pounds"}
                            fn={this.handleChange}
                            value={this.state.pounds.toString()}
                            placeholder={"pounds"}
                            disabled={this.props.disabled}
                        />
                    </div>
                </div>

                <div className={"col-4 d-inline-flex flex-column"}>
                    <div>Oz.</div>
                    <div>
                        <OwInputWrapper
                            type={"number"}
                            min={0}
                            name={"ounces"}
                            fn={this.handleChange}
                            value={this.state.ounces.toString()}
                            placeholder={"ounces"}
                            disabled={this.props.disabled}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default OwWeightSelector;
